import { createContext, useContext, useState, type ReactNode } from "react";
import dayjs from "dayjs";

export interface ChartPoint {
  name: string;
  current: number;
  previous: number;
}

interface StatsContextValue {
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
  setStartDate: (d: dayjs.Dayjs) => void;
  setEndDate: (d: dayjs.Dayjs) => void;
}

const StatsContext = createContext<StatsContextValue>({
  startDate: dayjs().subtract(30, "day"),
  endDate: dayjs(),
  setStartDate: () => {},
  setEndDate: () => {},
});

export function StatsProvider({ children }: { children: ReactNode }) {
  const [startDate, setStartDate] = useState(dayjs().subtract(30, "day"));
  const [endDate, setEndDate] = useState(dayjs());

  return (
    <StatsContext.Provider value={{ startDate, endDate, setStartDate, setEndDate }}>
      {children}
    </StatsContext.Provider>
  );
}

export function useStats() {
  return useContext(StatsContext);
}
